import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getUser } from "../../../../store/modules/session/selectors";
import { ROOT_FOLDER } from "../../../../store/modules/library/constants";
import { getActiveFolder } from "../../../../store/modules/library/selectors";

import { INITIAL_VALUES, FIELD_FOLDER_ID } from "../formSettings";

export const useCreateInitialValue = (user: ReturnType<typeof getUser>) => {
  const activeFolder = useSelector(getActiveFolder);

  return useMemo(() => ((user && activeFolder)
    ? ({
      ...INITIAL_VALUES,
      [FIELD_FOLDER_ID]: activeFolder === ROOT_FOLDER
        ? user.uid
        : activeFolder,
    })
    : INITIAL_VALUES
  ), [user, activeFolder]);
};
